import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';

const config = {
    apiKey: "AIzaSyC4IS7qf6OK94gBBAsac21WxstNu97_6II",
    authDomain: "karthikdattuch.firebaseapp.com",
    databaseURL: "https://karthikdattuch.firebaseio.com",
    projectId: "karthikdattuch",
    storageBucket: "karthikdattuch.appspot.com",
    messagingSenderId: "1085485124910",
    appId: "1:1085485124910:web:a625d7767e2de7ad8f3ebf"
}

let app, database, analytics;

try {
  app = initializeApp(config);
  
  // Initialize Analytics (only in browser environment)
  if (typeof window !== 'undefined') {
    try {
      analytics = getAnalytics(app);
    } catch (analyticsError) {
      console.log('Analytics initialization failed:', analyticsError);
      analytics = null;
    }
  }

  database = getDatabase(app);
} catch (error) {
  console.log('Firebase initialization failed:', error);
  // Provide fallback objects to prevent crashes
  app = null;
  database = null;
  analytics = null;
}

export { database, analytics };
export default app;